import React, { Component } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { deleteSelectedMediaIfOK, showAddSceneMediaModal, fetchMediaIfOK } from '../../actions';
import { AddSceneMediaModalController } from '../addSceneMediaModal';

class ActionSegment extends Component {
    render() {
        const { anySelected, deleteSelectedMediaIfOK, showAddSceneMediaModal, fetchMediaIfOK, scene, inScene } = this.props;

        return [
            <DropdownButton
                bsStyle='default'
                title='Media'
                key='media-1'
                id='media-dropdown-basic1'
            >
                <MenuItem eventKey="1" disabled={!inScene} onClick={() => showAddSceneMediaModal()}>
                    <i className="fas fa-plus"></i>&nbsp; New
                </MenuItem>
                <MenuItem eventKey="2" disabled={!inScene} onClick={() => fetchMediaIfOK(scene, true)}>
                    <i className="fas fa-sync-alt"></i>&nbsp; Refresh
                </MenuItem>
                <MenuItem eventKey="3" disabled={!anySelected || !inScene} onClick={() => deleteSelectedMediaIfOK(scene)}>
                    <i className="fas fa-trash-alt"></i>&nbsp; Delete Selected
                </MenuItem>
            </DropdownButton>,
            <AddSceneMediaModalController key='addscenemediamodal' />,
        ];
    }
}

const mapStateToProps = state => {
    return {
        scene: state.scene.current
    };
};

const mapDispatchToProps = {
    deleteSelectedMediaIfOK,
    showAddSceneMediaModal,
    fetchMediaIfOK
};

ActionSegment.propTypes = {
    inScene: PropTypes.bool.isRequired,
    anySelected: PropTypes.bool.isRequired,
    scene: PropTypes.string,
    deleteSelectedMediaIfOK: PropTypes.func.isRequired,
    showAddSceneMediaModal: PropTypes.func.isRequired,
    fetchMediaIfOK: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActionSegment);



// WEBPACK FOOTER //
// ./src/components/actionBar/ActionSegment.js